import request from '@/network/request'

/**
 * 
 * @returns 
 * 获取专家列表
 */
 export function getTeamList () {
  return request({
    url: 'website/team/list',
    method: 'get'
  })
}

/**
 * 会议通知
 */
 export function getNoticeDetail (data) {
  return request({
    url: 'website/meeting/notice',
    method: 'get',
    params: data
  })
}

/**
 * 新闻动态
 */
 export function getNewsDetail (data) {
  return request({
    url: 'website/meeting/dynamic',
    method: 'get',
    params: data
  })
}

/**
 * 图文教学列表
 */
 export function getGraphicteaching (data) {
  return request({
    url: 'website/graphicteaching/list',
    method: 'get',
    params: data
  })
}

/**
 * 学术文献
 */
 export function getaAcalitList (data) {
  return request({
    url: 'website/acalit/list',
    method: 'get',
    params: data
  })
}

/**
 * 病例中心
 */
 export function getCaseofillList (data) {
  return request({
    url: 'website/caseofill/list',
    method: 'get',
    params: data
  })
}

/**
 * 教学视频
 */
 export function getVideoList (data) {
  return request({
    url: 'website/videoteaching/list',
    method: 'get',
    params: data
  })
}

/**
 * 细胞阅片列表
 */
 export function getCellsection (data) {
  return request({
    url: 'website/cellsection/list',
    method: 'get',
    params: data
  })
}

/**
 * 获取细胞阅片详情
 */
 export function getCellsectDetail (id) {
  return request({
    url: 'website/cellsection/'+id,
    method: 'get',
  })
}

/**
 * 获取细胞阅片外链地址
 */
 export function getDictionary () {
  return request({
    url: 'prod-api/system/dict/data/type/xbxy_config',
    method: 'get',
  })
}

/**
 * 考试中心
 */
//  export function getExamlist (data) {
//   return request({
//     url: 'website/exam/examlist',
//     method: 'get',
//     params: data
//   })
// }
/**
 * 考试中心
 */
 export function getExamlist (data) {
  return request({
    url: 'cms/examuser/weblist',
    method: 'get',
    isToken: true,
    params: data
  })
}



/**
 * 获取考试试卷
 */
 export function getExamquestion (data) {
  return request({
    // url: 'website/exam/examquestion',
    url: 'web/exam/examquestion',
    method: 'post',
    data,
    isToken: true
  })
}

/**
 * 交卷
 */
 export function commitExamquestion (data) {
  return request({
    url: 'exam/handover',
    method: 'post',
    isToken: true,
    data
  })
}



/**
 * 获取首页banner图片列表
 */
 export function getBannerList () {
  return request({
    url: 'website/sitecfg/firstbanner',
    method: 'post',
  })
}

/**
 * 
 * @param {注册} data 
 * @returns 
 */
export function register (data) {
  return request({
    url: 'website/register',
    method: 'post',
    data
  })
}



/**
 * 
 * @param {登录} data 
 * @returns 
 */
 export function loginUser (data) {
  return request({
    url: 'website/login',
    method: 'post',
    data
  })
}

/**
 * 获取视频详情
 */
 export function getVideoDetail (videoId) {
  console.log("HUIQUAN------------ : "+ videoId)
  return request({
    url: 'website/videoteaching/'+videoId,
    method: 'get',
  })
}


/**
 * 获取视频播放地址
 */
 export function getVideoAddress (videoId) {
  return request({
    url: 'website/videoteaching/playurl/'+videoId,
    method: 'get',
  })
}

/**
 * 获取网站配置数据
 */
 export function getFirstcfg (data) {
  return request({
    url: 'website/sitecfg/firstcfg',
    method: 'post',
    data
  })
}

/**
 * 获取首页友情链接
 */
 export function getFirstcLink (data) {
  return request({
    url: 'website/sitecfg/firstlink',
    method: 'post',
    data
  })
}

/**
 * 搜索接口
 */
 export function getSearchData (data) {
  return request({
    url: 'website/keywords',
    method: 'post',
    params: data
  })
}
/**
 * 添加历史记录
 */
 export function setBrowerecord (broweType, broweContentId) {
  return request({
    url: 'cms/browerecord/add',
    method: 'post',
    isToken: true,
    data: {
      broweType: broweType,
      broweContentId: broweContentId
    }
  })
}
/**
 * 查询历史记录
 */
 export function getBrowerecord (data) {
  return request({
    url: 'cms/browerecord/list',
    method: 'get',
    isToken: true,
    params: data
  })
}

/**
 * 查询考试结果
 */
 export function getExamrecord (data) {
  return request({
    url: 'exam/examrecord/currlist',
    method: 'get',
    isToken: true,
    params: data
  })
}
/**
 * 考卷表头信息
 */
 export function getPaperHead (data) {
  return request({
    url: '/exam/exam/' + data,
    method: 'get',
    isToken: true
  })
}
/**
 * 考试结果信息
 */
 export function examrecordInfo (data) {
  return request({
    url: '/exam/examrecord/info/' + data,
    method: 'get',
    isToken: true
  })
}
/**
 * 修改密码
 */
 export function updatePwd (data) {
  return request({
    url: '/system/user/profile/updatePwd',
    method: 'put',
    isToken: true,
    params: data
  })
}
/**
 * 获取用户信息
 */
 export function getUserInfos (data) {
  return request({
    url: '/system/user/profile',
    method: 'get',
    isToken: true
  })
}
/**
 * 修改用户信息
 */
 export function upUserInfo (data) {
  return request({
    url: '/system/user/profile',
    method: 'put',
    isToken: true,
    data: data
  })
}
export function acalitSelect (data) {
 return request({
   url: '/website/acalit/select',
   method: 'post',
   data: data
 })
}


// WEBPACK FOOTER //
// ./src/network/api.js